import type { KpiCardSpec } from './card-spec';

/**
 * The Auto reissued promotions scalar, shown on the Acquisition page's Coupons
 * section and the Users page's User actions section. One object in two
 * catalogs, so the two pages cannot report different figures.
 */
export const AUTO_REISSUED_PROMOTIONS_SCALAR_CARD: KpiCardSpec = {
    title: 'Auto reissued promotions',
    source: 'coupon-activation',
    metric: 'reissued',
    form: 'number',
    size: 'sm',
};
